import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import "./Admin1.css";
import RequireAdmin1 from "./guards/RequireAdmin1";
import Admin1Layout from "./layout/Admin1Layout";
import DashboardPage from "./pages/DashboardPage";
import UsersPage from "./pages/UsersPage";
import UserDetailsPage from "./pages/UserDetailsPage";
import VerificationPage from "./pages/VerificationPage";
import VerificationQueuePage from "./pages/VerificationQueuePage";
import WithdrawEligibilityPage from "../admin/pages/WithdrawEligibilityPage";
import WithdrawRequestsPage from "../admin/pages/WithdrawRequestsPage";
import PaidWithdrawalsPage from "../admin/pages/PaidWithdrawalsPage";
import AccountingReportsPage from "../admin/pages/AccountingReportsPage";
import ReportsPage from "./pages/ReportsPage";
import SupportPage from "./pages/SupportPage";
import SupportTicketDetailsPage from "./pages/SupportTicketDetailsPage";
import FinancePage from "./pages/FinancePage";
import AuditLogsPage from "./pages/AuditLogsPage";

export default function Admin1App() {
  return (
    <RequireAdmin1>
      <Admin1Layout>
        <Routes>
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="user/:uid" element={<UserDetailsPage />} />
          <Route path="verification-queue" element={<VerificationQueuePage />} />
          <Route path="verification" element={<VerificationPage />} />
          <Route
            path="withdraw-eligibility"
            element={<WithdrawEligibilityPage />}
          />
          <Route
            path="withdraw-requests"
            element={<WithdrawRequestsPage />}
          />
          <Route
            path="paid-withdrawals"
            element={<PaidWithdrawalsPage />}
          />
          <Route
            path="accounting-reports"
            element={<AccountingReportsPage />}
          />
          <Route path="reports" element={<ReportsPage />} />
          <Route
            path="support/:ticketId"
            element={<SupportTicketDetailsPage />}
          />
          <Route path="support" element={<SupportPage />} />
          <Route path="finance" element={<FinancePage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />
          <Route path="*" element={<Navigate to="/admin1" replace />} />
        </Routes>
      </Admin1Layout>
    </RequireAdmin1>
  );
}
